
























































































































import {Component, Vue} from "vue-property-decorator";
import {namespace} from "vuex-class";
import Contract from "@/model/contract";
import QErrors from "@/common/qErrors.vue";
import contractApi from "@/api/contractApi";
import moment from "moment";
import qNotify from "@/common/qNotify";
import store from "@/store";
import _ from "lodash";
import {compareWithKeys} from "@/common/utils";
const auth = namespace("Auth");

@Component({
  name: "customerContractInformation",
  components: {
    QErrors,
  },
})
export default  class customerContractInformation extends Vue {
  @auth.Getter
  getCurrentyContract: Contract;

  public errors = {};
  public today = null;
  public current_email = '';

  public contractObject: Contract = new Contract();
  public contractObjectInit: Contract = new Contract();

  mounted() {
    this.today = moment();
    this.contractObject.contractor_id = this.getCurrentyContract.id;
    this.detail();
  }

  public async detail() {
    const result = await contractApi.detail(this.getCurrentyContract.id);
    if (result) {
      this.contractObject = result;
      this.current_email = this.contractObject.j_sys.email;
      this.contractObjectInit = _.cloneDeep(this.contractObject)
    }
  }

  public displayType(type: any) {
    return (type) ? '法人' : '個人';
  }

  public getFileName(filename: string, original_name: string) {
    return (filename) ? filename : ((original_name) ? original_name : '');
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        onConfirm: () => {
          this.$router.back();
        },
        onClose: () => {
          console.log("onClose");
        },
      });
    } else {
      this.$router.back();
    }
  }

  public async submit() {
    const result = await this.contractObject.j_sys.updateMe();
    if (result.meta.status === 200) {
      qNotify.success({
        text: this.$t("me.updated"),
      });
      this.errors = {};
      store.dispatch("Auth/setUser", result.data);
    } else {
      this.errors = result.meta.errors;
      qNotify.error({
        text: result.meta.message,
      });
    }
  }

  public async logout() {
    store.dispatch("Auth/logout");
  }

  public isChanged() {
    return compareWithKeys(this.contractObject.j_sys, this.contractObjectInit.j_sys, [
      'email',
      'password',
    ])
  }
}
